export const ACTIONS = Object.freeze({
  POPULATE: 'populate',
  QUERY: 'query',
  MARK_CONTACT_ADDED: 'markContactAdded',
  UNMARK_AS_GUEST: 'unmarkAsGuest',
});
